// extracted by mini-css-extract-plugin
export var printerCard = "_9s-1";
export var printerCardConfigured = "_9s-2";
export var printerCardError = "_9s-3";
export var printerCardsContainer = "_9s-0";
export var printerIcon = "_9s-8";
export var printerIconConfigured = "_9s-5";
export var printerIconContainer = "_9s-4";
export var printerIconError = "_9s-6";
export var printerIconUnconfigured = "_9s-7";
export var workstationsTableCard = "_9s-9";